var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAddImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32.000000pt",
    height: "32.000000pt",
    viewBox: "0 0 32.000000 32.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,32.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 287 c-2 -7 -3 -60 -2 -118 l3 -104 78 -3 c48 -2 77 1 77 8 0 6 -28 10 -70 10 -61 0 -70 2 -70 18 0 11 9 27 20 37 16 15 22 16 35 5 13 -11 20 -9 45 15 l30 29 25 -24 c37 -35 44 -14 7 22 l-32 32 -29 -28 c-26 -25 -33 -27 -46 -16 -13 11 -19 10 -35 -5 -20 -18 -20 -17 -20 48 l0 67 100 0 100 0 0 -70 c0 -42 4 -70 10 -70 7 0 10 29 8 78 l-3 77 -113 3 c-87 2 -114 0 -118 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 246 c-10 -26 4 -48 28 -44 17 2 23 10 23 28 0 18 -6 26 -23 28 -13 2 -25 -3 -28 -12z m36 -16 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 100 c0 -13 -7 -20 -20 -20 -11 0 -20 -4 -20 -10 0 -5 9 -10 20 -10 13 0 20 -7 20 -20 0 -11 5 -20 10 -20 6 0 10 9 10 20 0 13 7 20 20 20 11 0 20 5 20 10 0 6 -9 10 -20 10 -13 0 -20 7 -20 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddImage);
export default __webpack_public_path__ + "static/media/ic-add-image.9ed5d86ccdab29a2246b0185243a0889.svg";
export { ForwardRef as ReactComponent };